module.exports = __webpack_public_path__ + "img/facebook.feb8c61c.svg";